import { StyledCard } from '@/components/Card/StyledCard';
import { Heading } from '@/components/Text/Heading/Heading';
import { Button, Stack } from '@mantine/core';
import { type ReactNode } from 'react';

interface ButtonProps {
  label: ReactNode;
  onClick: () => void;
  variant?: string;
}

interface Props {
  header: string;
  buttons: ButtonProps[];
}

export const ButtonCard = (props: Props) => {
  const { header, buttons } = props;
  return (
    <StyledCard>
      <Stack gap="md">
        <Heading type="tertiary">{header}</Heading>
        {buttons.map(button => (
          <Button
            key={button.label?.toString()}
            onClick={button.onClick}
            variant={button.variant ?? 'outline'}
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              display: 'block',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {button.label}
          </Button>
        ))}
      </Stack>
    </StyledCard>
  );
};
